import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CustomerSurfaceAccessService } from './customer-surface-access.service';
import { AppStore } from './store';

export const customerSurfaceGuard: CanActivateFn = (_route, state) => {
  const access = inject(CustomerSurfaceAccessService);
  const store = inject(AppStore);
  const router = inject(Router);
  // The shell owns authentication bootstrap. Feature load methods also gate before fetching,
  // including while that bootstrap has not yet supplied a user.
  if (!store.user()) return true;
  // Do not judge a still-loading membership/capability projection as a final refusal.
  // The reactive outlet and feature load gates handle those scoped proofs in place.
  const isUsage = state.url.split(/[?#]/, 1)[0] === '/admin/org-usage';
  if (isUsage ? access.hasCustomerAdminAudience() : access.isCustomer()) return true;
  return router.createUrlTree(['/customer-access-refused']);
};
